export default __webpack_public_path__ + "static/hero-75e82fce0179c26ad5b4e6d20d97d3f9.png";